import { render, staticRenderFns } from "./ManageOrganizationsPage.vue?vue&type=template&id=cd4e349c&scoped=true"
import script from "./ManageOrganizationsPage.vue?vue&type=script&lang=ts"
export * from "./ManageOrganizationsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4e349c",
  null
  
)

export default component.exports